import { css } from '@linaria/core';
import { breakpoints, theming } from 'styles/utils';
export const orgInviteWrapper = "odules__Organizations__components__OrgInvitation__OrgInvitation_styles_ts-orgInviteWrapper-o6e3m1p";

require("./OrgInvitation.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./OrgInvitation.styles.ts");